
import LoginPage from "@/pages/LoginPage.vue";
import chartPage from "@/pages/ChartPage.vue";

import { useStore } from 'vuex'
import { computed } from 'vue'

export default {
  components: {
    LoginPage,
    chartPage,
  },
  setup(){
    const store = useStore();
    const isLoggedIn = computed(() => !!store.state.token);
    console.log("####################@@@@@@@@@@@@@@@@@@@@@ userPermission HOME: ");

    return {
      isLoggedIn
    }
  }
}
